<template>
  <div>
    <div>
      <div class="d-flex align-center">
        <div class="text-4">Ethereum</div>
        <v-divider vertical class="ml-6 mr-6"></v-divider>
        <img
          src="@/assets/icons/networks/ethereum.svg"
          alt=""
          height="20"
          width="20"
        />
      </div>
      <div class="mt-5">
        <div class="d-none d-md-flex align-center px-6 text-6 darkgray--text w-header">
          <div class="flex-1">Wallet</div>
          <div class="flex-3">Address</div>
          <div class="flex-1 d-flex align-center">
            <span>Connections</span>
            <v-tooltip bottom color="dark" max-width="260px">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="gray--text ml-1" v-bind="attrs" v-on="on"
                  >mdi-information</v-icon
                >
              </template>
              <span
                >Shows which Unagii product the connected wallet is interacting
                with.</span
              >
            </v-tooltip>
          </div>
          <div class="flex-2">Manage</div>
        </div>
        <wallet-items :items="ethereumWallets" class="d-none d-md-block" />
        <wallet-items-mobile
          :items="ethereumWallets"
          class="d-block d-md-none"
        />
      </div>
    </div>
    <div class="mt-10">
      <div class="d-flex align-center">
        <div class="text-4">Tendermint</div>
        <v-divider vertical class="ml-6 mr-6"></v-divider>
        <img
          src="@/assets/icons/networks/tendermint.svg"
          alt=""
          height="20"
          width="20"
        />
      </div>
      <div class="mt-5">
        <div class="d-none d-md-flex align-center px-6 text-6 darkgray--text w-header">
          <div class="flex-1">Wallet</div>
          <div class="flex-3">Address</div>
          <div class="flex-1 d-flex align-center">
            <span>Connections</span>
            <v-tooltip bottom color="dark" max-width="260px">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="gray--text ml-1" v-bind="attrs" v-on="on"
                  >mdi-information</v-icon
                >
              </template>
              <span
                >Shows which Unagii product the connected wallet is interacting
                with.</span
              >
            </v-tooltip>
          </div>
          <div class="flex-2">Manage</div>
        </div>
        <wallet-items :items="tendermintWallets" class="d-none d-md-block" />
        <wallet-items-mobile
          :items="tendermintWallets"
          class="d-block d-md-none"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import WalletItems from "./WalletItems";
import WalletItemsMobile from "./WalletItemsMobile";

export default {
  components: {
    WalletItems,
    WalletItemsMobile,
  },
  computed: {
    ...mapGetters({
      isUser: "auth/isUser",
      walletList: "userWallets/walletList",
      projectByNetworkMap: "projectConfig/projectByNetworkMap",
    }),
    ethereumWallets() {
      if (!this.walletList.result) return [];
      return this.walletList.result.filter(
        item => item.coin_network === "ethereum"
      );
    },
    tendermintWallets() {
      if (!this.walletList.result) return [];
      return this.walletList.result.filter(
        item => item.coin_network !== "ethereum"
      );
    },
  },
  mounted() {
    this.$store.dispatch("userWallets/fetchOtherInfo");
  },
};
</script>

<style lang="scss" scoped>
.w-header {
  height: 30px;
  background: rgba(249, 234, 232, 0.15);
  border: 1px solid #f9eae8;
  border-radius: 8px;
}
</style>
